import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import { getUrlParameter, hasUrlParameter, forceInt, dateDisplay } from "../functions";

$(function() {
    const $fileField = $('#MemberReviewForm_MemberReviewForm_Images'),
        $memberReviewsFormImageThumbnails = $('#memberReviewsFormImageThumbnails'),
        deletedImages = new Set();

    const $star = $('.member-review-rating-star');
    if ($star.length) {
        const $ratingHiddenField = $('#MemberReviewForm_MemberReviewForm_Rating');
        $star.on('mouseover', function() {
            const rating = forceInt($(this).data('value'));

            starsHighlight(rating);
        });

        $star.on('mouseout', function() {
            const rating = forceInt($ratingHiddenField.val());

            starsHighlight(rating);
        });

        $star.on('click', function() {
            const rating = forceInt($(this).data('value'));
            $ratingHiddenField.val(rating);

            starsHighlight(rating);
        });


    }

    function starsHighlight(rating) {
        const $star = $('.member-review-rating-star');
        if ($star.length) {
            $star.each(function() {
                const $this = $(this),
                    ratingValue = forceInt($this.data('value'));
                if (ratingValue <= rating) {
                    $this.addClass('selected');
                } else {
                    $this.removeClass('selected');
                }
            });
        }
    }

    function starsClear() {
        const $star = $('.member-review-rating-star');
        if ($star.length) {
            $star.each(function() {
                const $this = $(this);

                $this.removeClass('selected');
            });
        }
    }

    const $memberReviewFormModalTrigger = $('.member-review-form-modal-trigger'),
        $memberReviewFormModal = $('#memberReviewFormModal');
    if ($memberReviewFormModalTrigger.length && $memberReviewFormModal.length) {
        $memberReviewFormModalTrigger.on('click', function(e) {
            e.preventDefault();

            const $this = $(this),
                $memberReviewFormPageIdField = $('#MemberReviewForm_MemberReviewForm_PageID'),
                $memberReviewFormPageIdFieldHolder = $('#MemberReviewForm_MemberReviewForm_PageID_Holder'),
                pageId = forceInt($this.data('page-id')),
                pageTitle = $this.data('page-title');
            if (pageId > 0) {
                $memberReviewFormPageIdField.val(pageId);
                $memberReviewFormPageIdFieldHolder.hide();
                // $memberReviewFormModal.find('.member-review-page-title').text(pageTitle);
            }
            $memberReviewFormModal.modal('show');
        });

        const $memberReviewAction = $('.member-review-action');
        if ($memberReviewAction.length) {
            const action = $memberReviewAction.data('action'),
                pageId = forceInt($memberReviewAction.data('page-id'));
            if (action === 'open-form-modal') {
                const $mrfModalTrigger = $('.member-review-form-modal-trigger[data-page-id="' + pageId + '"]');
                if ($mrfModalTrigger.length) {
                    $mrfModalTrigger.trigger('click');
                }
            }
        }
    }

    const $memberReviewForm = $('#MemberReviewForm_MemberReviewForm');
    if ($memberReviewForm.length) {
        $memberReviewForm.on('submit', function(e) {
            e.preventDefault();

            const $this = $(this),
                formAction = $this.attr('action'),
                $submitButton = $('#MemberReviewForm_MemberReviewForm_action_doSubmit'),
                $messages = $('#member-review-form-messages'),
                $modalBody = $memberReviewFormModal.find('.modal-body'),
                $memberReviewFormPageIdFieldHolder = $('#MemberReviewForm_MemberReviewForm_PageID_Holder');
            let submitButtonValue = $submitButton.val();

            const formData = new FormData();

            $this.serializeArray().forEach(field => {
                formData.append(field.name, field.value);
            });

            const files = $fileField[0].files;
            for (let n = 0; n < files.length; n++) {
                if (!deletedImages.has(n)) {
                    formData.append('Images[]', files[n]);
                }
            }

            $messages.html('');
            $submitButton.attr('disabled', true);
            $submitButton.val(hpaTranslatedtext.memberReviews.form.buttonProcessingText); // Processing...

            $.ajax({
                url: formAction,
                type: 'POST',
                data: formData,
                processData: false,  // Important for file uploads
                contentType: false,  // Important for file uploads
                dataType: 'json',
                success: function(data) {
                    // console.log(data);
                    if (typeof data === 'object' && 'status' in data) {
                        if (data.status === 1) {
                            const $pageDropdown = $('#MemberReviewForm_MemberReviewForm_PageID'),
                                $pageDropdownSelectedOption = $pageDropdown.find('option:selected');
                            let pageId = $pageDropdown.val();
                            $memberReviewForm.trigger('reset');
                            starsClear();
                            $pageDropdown.val(pageId);
                            $pageDropdownSelectedOption.text($pageDropdownSelectedOption.text() + ' ✅');
                            $memberReviewsFormImageThumbnails.html('');
                            if ($memberReviewFormPageIdFieldHolder.is(':hidden')) {
                                $this.hide();
                            }
                        }
                        if (data.messages.length) {
                            data.messages.forEach(message => {
                                $messages.append('<div class="alert alert-' + message.type + '">' + message.text + '</div>');
                            });
                        }
                    } else if ($.isArray(data) && (data.length > 0) && (typeof data[0] === 'object')) {
                        // It's a internal field error e.g. Google reCaptcha
                        data.forEach(item => {
                            if ('message' in item) {
                                $messages.append('<div class="alert alert-danger">' + item.message + '</div>');
                            }
                        });
                    }

                    $modalBody.scrollTop(0);
                    $submitButton.val(submitButtonValue);
                    $submitButton.removeAttr('disabled');
                },
                error: function(xhr, status, error) {
                    $messages.append('<div class="alert alert-danger">An error occurred: ' + error + '</div>');
                    $submitButton.val(submitButtonValue);
                    $submitButton.removeAttr('disabled');                }
            });

            return false;
        });
    }

    const $memberReviewsSortDropdown = $('.member-reviews-sort-dropdown');
    if ($memberReviewsSortDropdown.length) {
        $memberReviewsSortDropdown.on('click', function(e) {
            e.preventDefault();

            const $this = $(this),
                value = $this.find('option:selected').data('value'),
                $memberReviewsWrapper = $this.parents('.member-reviews'),
                $loadMoreBtn = $memberReviewsWrapper.find('.load-more-button'),
                $reviewItemsWrapper = $memberReviewsWrapper.find('.review-list'),
                currentParamsExtra = $loadMoreBtn.data('params-extra');

            let newParamsExtra = 'sort=' + value;
            if (typeof currentParamsExtra === 'string' && currentParamsExtra !== '') {
                newParamsExtra = mergeQueryStrings(currentParamsExtra, newParamsExtra);
            }

            $reviewItemsWrapper.html('');
            $loadMoreBtn.data('params-extra', newParamsExtra);
            $loadMoreBtn.data('start', 0);
            $loadMoreBtn.trigger('click');
            $loadMoreBtn.data('data-start', $loadMoreBtn.data('data-limit'));
        });
    }

    if ($fileField.length) {
        $fileField.on('click', function(e) {
            const $this = $(this);

            $this.val('');
            $memberReviewsFormImageThumbnails.html('');
            deletedImages.clear();
        });

        $fileField.on('change', function(e) {
            if (!e.target.files) return;

            const files = e.target.files;
            if (files.length) {
                for (let n = 0, m = files.length; n < m; n++) {
                    if (n === 3) break;
                    const $imageLi = $(
                        '<li>' +
                            '<img src="' + URL.createObjectURL(files[n]) + '" data-file-index="' + n + '" />' +
                            '<button class="remove-image">&times;</button>' +
                        '</li>'
                    );
                    $imageLi.find('img').on('load', function() {
                        const $this = $(this);

                        URL.revokeObjectURL($this.attr('src'));
                    });
                    $memberReviewsFormImageThumbnails.append($imageLi);
                }
            }
        });

        $memberReviewsFormImageThumbnails.on('click', '.remove-image', function() {
            const $this = $(this),
                $img = $this.siblings('img'),
                fileIndex = $img.data('file-index');

            deletedImages.add(fileIndex);
            $this.parent().remove();
        });

        const $imageThumbnailsUl = $('#memberReviewsFormImageThumbnails');
        if ($imageThumbnailsUl.length) {
            $imageThumbnailsUl.find('li img').on('click', function() {
                const $this = $(this);

                $this.remove();
            });
        }
    }

    // const $imageHolder = $('#MemberReviewForm_MemberReviewForm_Images_Holder');
    // if ($imageHolder.length) {
    //     $imageHolder.on('click', function() {
    //         const $fileInput = $('#MemberReviewForm_MemberReviewForm_Images');
    //         if ($fileInput.length) {
    //             $fileInput.trigger('click');
    //         }
    //     });
    // }

    function mergeQueryStrings(queryString1, queryString2) {
        // Function to convert query string to an object
        function parseQueryString(queryString) {
            return queryString.split('&').reduce((acc, param) => {
                const [key, value] = param.split('=');
                acc[decodeURIComponent(key)] = decodeURIComponent(value);
                return acc;
            }, {});
        }

        // Function to convert an object back to a query string
        function toQueryString(obj) {
            return Object.entries(obj)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
        }

        // Parse both query strings
        const params1 = parseQueryString(queryString1);
        const params2 = parseQueryString(queryString2);

        // Merge the two objects, with params2 overwriting params1
        const mergedParams = Object.assign({}, params1, params2);

        // Convert the merged object back to a query string
        return toQueryString(mergedParams);
    }

});



// WEBPACK FOOTER //
// ./js/modules/memberReviews.js